import React, {useContext, useState, useEffect} from 'react';
import UserUpload from '../../api/services/v2/UserUpload'
import './fileUpload.css';
import FileUploadTable from './FileUploadTable';
import {
    handleExtractDimensions,
    handleImageDimensions,
    handleVideoDimensions
} from 'components/util/extractDimensions/extractDimensions';
import {UserContext} from 'context/UserContext';
import {extractUserInfo} from 'components/util/dataFormat/dataformat';

const initialFileData = {
    name: [],
    landingPages: [],
    adSizes: [],
};
const FileUploadUI = () => {
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [errorMessage, setErrorMessage] = useState("")
    const [loadingUpload, setLoadingUpload] = useState(false)
    const [showSuccess, setShowSuccess] = useState(false)
    const {userInfo} = useContext(UserContext);
    const userData = extractUserInfo(userInfo);

    useEffect(() => {
        if (errorMessage !== "") {
            setTimeout(function () {
                setErrorMessage("")
            }, 3000)
        }
    }, [errorMessage]);


    useEffect(() => {
        if (showSuccess) {
            setTimeout(function () {
                setShowSuccess(false)
            }, 3000)
        }
    }, [showSuccess]);


    const [fileData, setFileData] = useState({
        name: [],
        landingPages: [],
        adSizes: [],
    });
    const [fileChangeIndex, setFileChangeIndex] = useState(null);
    const handleFileChange = async (event) => {
        const files = event.target.files;

        if (files && files.length > 0) {
            const newFiles = [];

            for (let i = 0; i < uploadedFiles.length; i++) {
                newFiles.push(uploadedFiles[i]);
            }
            const zipFileTypes = ['application/zip', 'application/x-zip-compressed']
            const imgFileTypes = ['image/jpeg', 'image/gif', 'image/png']
            const videoFiletypes = ['video/mp4']
            const adImageFormats = ['300x250', '300x600', '728x90', '300x50', '320x50', '320x100', '970x250', '160x600', '336x280', '320x100', '970x90', '468x60', '120x600', '250x250', '180x150', '234x60', '300x50', '320x480', '480x320', '216x36', '168x28', '120x20']
            const adVideoFormats = ['1280x720']
            for (let i = 0; i < files.length; i++) {

                if (zipFileTypes.includes(files[i].type)) {
                    const dimensions = await handleExtractDimensions(files[i], setErrorMessage);
                    if (!dimensions?.width && !dimensions?.height) {
                        continue;
                    }
                }

                if (imgFileTypes.includes(files[i].type)) {
                    if (files[i].size > 150000) {
                        setErrorMessage(`${files[i].name} cannot be added because it has more than 150 kb`)
                        continue
                    }
                    let imageDimensions = await handleImageDimensions(files[i]);
                    let imageFormat = `${imageDimensions.width}x${imageDimensions.height}`
                    if (!adImageFormats.includes(imageFormat)) {
                        setErrorMessage(`${files[i].name} cannot be added because its dimensions (${imageFormat}) do not match a known ad format`)
                        continue
                    }

                }

                if (videoFiletypes.includes(files[i].type)) {
                    if (files[i].size > 1000000000) {
                        setErrorMessage(`${files[i].name} cannot be added because it has more than 1GB`)
                        continue
                    }
                    let videoDimensions = await handleVideoDimensions(files[i])
                    let videoFormat = `${videoDimensions.width}x ${videoDimensions.height}`
                    if (!adVideoFormats.includes(videoFormat)) {
                        setErrorMessage(`${files[i].name} cannot be added because its dimensions (${videoFormat}) do not match a known ad format`)
                        continue
                    }
                }

                if (fileChangeIndex) {
                    newFiles[fileChangeIndex] = files[i];
                } else {
                    newFiles.push(files[i]);
                }
            }
            if (newFiles.length > 21) {
                setErrorMessage('You can select a maximum of 21 files');
                return;
            }
            setUploadedFiles(newFiles);
            setFileChangeIndex(null);
        } else {
            setErrorMessage('No files selected');
            setFileChangeIndex(null);
        }
    };

    const handleBrowseClick = (inputId) => {
        document.getElementById(inputId).click();

    };

    const isValidHttpUrl = (string) => {
        let url;
        try {
            url = new URL(string);
        } catch (_) {
            return false;
        }
        return url.protocol === "http:" || url.protocol === "https:";
    }

    const handleConfirmUpload = async () => {
        if (uploadedFiles.length < 1) {
            setErrorMessage('Please select a minimum of 1 file.')
            return
        }
        if (uploadedFiles.length > 21) {
            setErrorMessage('You can select a maximum of 21 files.')
            return
        }
        for (let landingPage of fileData['landingPages']) {
            if (landingPage === '' || !isValidHttpUrl(landingPage)) {
                setErrorMessage('Please enter a valid landing page for all items')
                return
            }
        }
        setLoadingUpload(true)
        await UserUpload(uploadedFiles, userData, setErrorMessage, setLoadingUpload, setShowSuccess, setFileData, setUploadedFiles);
    };
    const handleSizeClick = (index) => {
        const ext = fileData.name[index].split('.').pop();
        const imageExtensions = ['png', 'jpg', 'jpeg', 'gif'];
        if (imageExtensions.includes(ext)) {
            document.getElementById('fileInput').click();
        } else if (ext === 'zip') document.getElementById('fileInput-zip').click();
        else if (ext === 'mp4') document.getElementById('fileInput-vid').click();
        else document.getElementById('fileInput').click();
        setFileChangeIndex(index);
    };

    return (
        <div className="container-wrapper">
            <div>
                <div className="main-wrapper">
                    <h5>Upload Ads & Assign Landing Pages</h5>
                    <div className="cards-group">
                        <div className="card-main">
                            <div className="card-block">
                                <div className="cards-wrap-content">
                                    <h5>Upload Static Ad(s)</h5>
                                    <p className="file-extension">(.jpg, .png or .gif)</p>
                                    <p className="intro-add"><a
                                        href="https://docs.catalytics.io/docs/creative/banner-creative-asset-specifications"
                                        target="_blank">instructions & examples</a></p>
                                </div>
                                <input
                                    type="file"
                                    id="fileInput"
                                    multiple
                                    accept=".jpg,.jpeg,.png,.gif"
                                    onChange={handleFileChange}
                                    className='brows-btn'
                                />
                            </div>
                        </div>

                        <div className="card-main">
                            <div className="card-block">
                                <div className="cards-wrap-content">
                                    <h5>Upload HTML5/JS Ad(s)</h5>
                                    <p className="file-extension">(.zip)</p>
                                    <p className="intro-add"><a
                                        href="https://docs.catalytics.io/docs/creative/html5-creative-specifications"
                                        target="_blank">instructions & examples</a></p>
                                </div>
                                <div className="browse-button">
                                    <input
                                        type="file"
                                        id="fileInput-zip"
                                        multiple
                                        accept=".zip"
                                        onChange={handleFileChange}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="card-main">
                            <div className="card-block">
                                <div className="cards-wrap-content">
                                    <h5>Upload Video Ad(s)</h5>
                                    <p className="file-extension">(.mp4)</p>
                                    <p className="intro-add"><a
                                        href="https://docs.catalytics.io/docs/creative/video-creative-specifications"
                                        target="_blank">instructions & examples</a></p>
                                </div>
                                <input
                                    type="file"
                                    id="fileInput-vid"
                                    multiple
                                    accept=".mp4"
                                    onChange={handleFileChange}
                                    //style={{ display: 'none' }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                {(errorMessage !== "") ? <div className="error-container">{errorMessage}</div> : ""}
                {(showSuccess) ? <div className="success-message">The files were uploaded successfully</div> : ""}
                <FileUploadTable
                    uploadedFiles={uploadedFiles}
                    handleuploadedFiles={(file) => setUploadedFiles(file)}
                    setFileData={(data) => setFileData(data)}
                    fileData={fileData}
                    handleSizeClick={handleSizeClick}
                />
            </div>
            <div className="confirm-upload-btn">
                {(loadingUpload) ? <div className="loader"></div> :
                    <button className="button secondary" onClick={handleConfirmUpload}>
                        confirm & upload
                    </button>}
            </div>
        </div>

    );
};

export default FileUploadUI;
